<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs headline="Thiết lập thông báo"
        :link="[{ text: 'Phân quyền thông báo', href: '/settings-notification' }]" />
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <ConfigRoleFilter :listRole="listRole" :listConfig="listConfig" @onFilterChanged="onFilterChanged" />
    </v-card>
    <div v-if="listRolePolicies.length === 0" class="elevation-0">
      <RoleBlankView />
    </div>
    <v-card v-else outlined class="mx-4 elevation-0">
      <SetupPolicy :RolePolicies="RolePolicies" :selectedRole="selectedRole" :selectePolicy="selectedPoliicy"
        @updatePolicies="updatePolicies" />
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import RoleBlankView from '@/modules/settingNotification/RoleBlankView.vue'
import ConfigRoleFilter from '@/modules/settingNotification/ConfigRoleFilter.vue'
import SetupPolicy from '@/modules/settingNotification/SetupPolicyForm'
import { getFirestore, onSnapshot, collection, updateDoc, doc } from 'firebase/firestore'
export default {
  components: {
    Breadcrumbs,
    ConfigRoleFilter,
    RoleBlankView,
    SetupPolicy
  },
  async created() {
    if (this.firebaseApp) {
      this.setupFireStore()
    }
  },
  watch: {
    firebaseApp: {
      async handler(val) {
        if (val) this.setupFireStore(val)
      }
    },
  },
  data() {
    return {
      listRolePolicies: [],
      listRole: [],
      listConfig: [],
      selectedPoliicy: '',
      RolePolicies: {}
    }
  },
  computed: {
    ...mapGetters({
      firebaseApp: 'firebase/firebaseApp',
      role: 'auth/role',
    }),
  },
  methods: {
    setupFireStore(app) {
      const db = getFirestore(app)
      onSnapshot(collection(db, 'roleNoti'), querySnapshot => {
        this.listRole = []
        querySnapshot.forEach(doc => {
          if (doc.exists()) {
            const data = doc.data()
            data.id = doc.id
            this.listRole.push(data)
          } else {
            console.error('Document does not exist.')
          }
        })
        this.listRole.sort((a, b) => a.index - b.index)
      })
      onSnapshot(collection(db, 'policies'), querySnapshot => {
        this.listConfig = []
        querySnapshot.forEach(doc => {
          if (doc.exists()) {
            const data = doc.data()
            data.id = doc.id
            this.listConfig.push(data)
          } else {
            console.error('Document does not exist.')
          }
        })
        this.listConfig.sort((a, b) => a.index - b.index)
      })
    },
    async onFilterChanged(params) {
      this.$loading.active = true
      this.listRolePolicies = []
      this.selectedRole = params.role
      this.RolePolicies = params.config
      this.listRolePolicies = params.config.policies
      this.$loading.active = false
    },
    async updatePolicies(policies) {
      let allPolicies = []
      this.listConfig.forEach(i => {
        allPolicies = [...allPolicies, ...i.policies]
      })
      const truePolicies = allPolicies.filter(i => i.role.includes(this.selectedRole.name))
      const db = getFirestore()
      let newPolicies = []
      truePolicies.forEach(async i => {
        newPolicies.push(i.type)
      })
      const RolePolicies = policies.map(item => ({ name: item.name, type: item.type, role: item.role }))
      await updateDoc(doc(db, 'roleNoti', this.selectedRole.id), { policies: newPolicies })
      await updateDoc(doc(db, 'policies', this.RolePolicies.id), { policies: RolePolicies })
      this.$alert.success('Cập nhật quyền thành công vui lòng reload lại trang để có thể sử dụng quyền')
    }
  }
}
</script>
<style scoped></style>
